import React, { PropsWithChildren } from 'react';
import { CallToAction } from '../../../commonTypes/links';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import fluidGridColumns from '../../../theme/fluidGridColumns';
import { CardColumnSpanCalculator, CardGrid } from '../../CardGrid';
import { PrimaryCta } from '../../Cta';
import { CardGridContainer, CtaWrapper, Heading, Subheading } from './styles';

type ContactCardGridProps = {
  alignLeft?: boolean;
  cta?: CallToAction;
  heading?: string;
  subheading?: string;
} & ComponentProps;

export const columnSpanCalculator: CardColumnSpanCalculator = () => ({
  mobile: fluidGridColumns.mobile,
  tabletPortrait: fluidGridColumns.tabletPortrait / 2,
  tabletLandscape: fluidGridColumns.tabletLandscape / 3,
  desktop: fluidGridColumns.desktop / 3,
});

const ContactCardGrid: React.FC<PropsWithChildren<ContactCardGridProps>> = ({
  children,
  alignLeft,
  cta,
  heading,
  subheading,
  ...props
}) => {
  const hasCta = !!cta;

  return (
    <CardGridContainer hasCta={hasCta} {...componentProps(props)}>
      {(heading || subheading) && (
        <div tabIndex={0}>
          {heading && <Heading>{heading}</Heading>}
          {subheading && <Subheading>{subheading}</Subheading>}
        </div>
      )}
      <CardGrid alignLeft={alignLeft} columnSpanCalculator={columnSpanCalculator}>
        {children}
      </CardGrid>
      {cta && (
        <CtaWrapper>
          <PrimaryCta cta={cta} />
        </CtaWrapper>
      )}
    </CardGridContainer>
  );
};

export default applyComponentTheme(ContactCardGrid, 'ContactCardGrid');
